/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloModulo from 'Infotrack@Modelos/administracion/modulo';
import IModulo from 'Infotrack@Modelos/administracion/modulo/entidades/modulo';

export default class ControladorModeloModulo {
    private modeloModulo: ModeloModulo;
    constructor() {
        this.modeloModulo = new ModeloModulo();
    }

    public consultarModulo() {
        return this.modeloModulo.consultarModulo().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearModulo(modulo: IModulo) {
        await this.modeloModulo.crearModulo(modulo);
    }

    public async editarModulo(modulo: IModulo) {
        await this.modeloModulo.editarModulo(modulo);
    }

    public async eliminarModulo(modulo: IModulo) {
        await this.modeloModulo.eliminarModulo(modulo);
    }

    public validarEntidad(modulo: IModulo): boolean {
        if (modulo.NombreModulo === '') {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
